// src/LicenseRoutes.jsx
import React from 'react';
import { Routes, Route, Outlet, useLocation } from 'react-router-dom';

import VendorHome from './pages/VendorHome';
import VendorForm from './pages/VendorForm';
import VendorConfirm from './pages/VendorConfirm';
import VendorSuccess from './pages/VendorSuccess';
import VendorList from './pages/VendorList';
import VendorEdit from './pages/VendorEdit';
import AdminHome from './pages/AdminHome';

export default function LicenseRoutes({ user, signOut, role, companyName, fullName, managementAddress }) {
  const location = useLocation();
  console.log('[LicenseRoutes] current pathname:', location.pathname);
  console.log('[LicenseRoutes] role:', role);
  console.log('[LicenseRoutes] companyName:', companyName);
  console.log('[LicenseRoutes] fullName:', fullName);
  console.log('[LicenseRoutes] managementAddress:', managementAddress);

  if (!role || !companyName || !fullName || !managementAddress) {
    return (
      <div className="container">
        <h2 className="title">読み込み中...</h2>
      </div>
    );
  }

  const handleSignOut = () => {
    localStorage.clear();
    signOut();
  };

  const VendorLayout = () => <Outlet />;

  return (
    <Routes>
      {role === 'vendor' && (
        <Route path="" element={<VendorLayout />}>
          <Route index element={<VendorHome userId={user?.signInDetails?.loginId} companyName={companyName} fullName={fullName} managementAddress={managementAddress} onSignOut={handleSignOut} />} />
          <Route path="new-request" element={<VendorForm userId={user?.signInDetails?.loginId} companyName={companyName} fullName={fullName} managementAddress={managementAddress} onSignOut={handleSignOut} />} />
          <Route path="confirm-request" element={<VendorConfirm userId={user?.signInDetails?.loginId} companyName={companyName} fullName={fullName} managementAddress={managementAddress} onSignOut={handleSignOut} />} />
          <Route path="success" element={<VendorSuccess />} />
          <Route path="orders" element={<VendorList />} />
          <Route path="edit" element={<VendorEdit />} />
          <Route path="*" element={<div className="container"><h2 className="title">存在しないページです</h2></div>} />
        </Route>
      )}

      {role === 'admin' && (
        <Route path="" element={<AdminHome user={user} onSignOut={handleSignOut} />} />
      )}
    </Routes>
  );
}
